export const defaultWidths = ['620px', '780px', '940px'];
